import React from "react";

export default function Marquee({ items = [] }) {
  const list = items.length ? items : ["Clipup"];
  // repeat so a group is always wider than the container
  const rep = [...list, ...list, ...list, ...list];
  const Group = ({ hidden }) => (
    <div className="mq-group" aria-hidden={hidden || undefined}>
      {rep.map((t, i) => (
        <span key={i} style={{ display: "flex", alignItems: "center", gap: 40 }}>
          <span style={{ whiteSpace: "nowrap", fontSize: 14, fontWeight: 500, color: "#e6ebff" }}>{t}</span>
          <span aria-hidden="true" style={{ width: 6, height: 6, borderRadius: 999, background: "#5b7cff", flexShrink: 0 }} />
        </span>
      ))}
    </div>
  );
  return (
    <div className="mq" data-testid="marquee">
      <div className="mq-track">
        <Group />
        <Group hidden />
      </div>
    </div>
  );
}
